import React from "react";
import Model from "@tripian/model";
import { SvgIcons } from "@tripian/react";
import useAuth from "../../../../hooks/useAuth";
import ICombinedState from "../../../../redux/model/ICombinedState";
import { useSelector } from "react-redux";
import { useGuestUserForSimplyCaribbean } from "../../../../hooks/useGuestUserForSimplyCaribbean";
import classes from "./Menu.module.scss";

interface IMenu {
  listShown: boolean;
  sharedTrip: boolean;
  isInTripPlan?: boolean;
  showList: (event: React.MouseEvent<HTMLInputElement, MouseEvent>) => void;
  showFavorites: () => void;
  showOffers: () => void;
  showBookings?: () => void;
  showProfile?: () => void;
  t: (value: Model.TranslationKey) => string;
}

const Menu: React.FC<IMenu> = ({
  listShown,
  sharedTrip,
  isInTripPlan,
  showList,
  showFavorites,
  showOffers,
  showBookings,
  showProfile,
  t,
}) => {
  let { readOnlyTrip } = useSelector((state: ICombinedState) => ({
    readOnlyTrip: state.trip.readOnly,
  }));

  const { isLoggedIn } = useAuth();

  readOnlyTrip = false;
  const isGuestForSimplyCaribbean = useGuestUserForSimplyCaribbean();

  return (
    <div className={classes.menu}>
      {sharedTrip && window.tconfig.WIDGET_THEME_1 ? (
        <>
          <div
            className={
              listShown ? `${classes.circle} ${classes.shadow}` : classes.circle
            }
          >
            <input
              className={listShown ? classes.mapIcon : classes.listIcon}
              type="button"
              onClick={showList}
            />
          </div>
          {isLoggedIn && (
            <div
              className={`${classes.mitem} ${classes.offers}`}
              onClick={showOffers}
              onKeyDown={() => {}}
              role="button"
              tabIndex={0}
            />
          )}
        </>
      ) : (
        <div className="flex w-full justify-between items-center px-4">
          {/* DEALS */}
          {/* {window.tconfig.DEALS_PAGE_URL && !(sharedTrip && window.tconfig.WIDGET_THEME_1) && isInTripPlan && (
            <div className={classes.iconWrapper} onClick={() => window.open(window.tconfig.DEALS_PAGE_URL)} role="button" tabIndex={0}>
              <SvgIcons.Star2 width="20" height="20" />
            </div>
          )} */}

          {!isGuestForSimplyCaribbean &&
            readOnlyTrip === false &&
            isInTripPlan &&
            isLoggedIn && (
              <div
                className={classes.iconWrapper}
                onClick={showProfile}
                onKeyPress={() => {}}
                role="button"
                tabIndex={0}
              >
                <SvgIcons.User />
                <span className="text-xs mt-1">
                  {t("user" as Model.TranslationKey)}
                </span>
              </div>
            )}

          {/* FAVORITES */}
          {readOnlyTrip === false &&
            !isGuestForSimplyCaribbean &&
            !(sharedTrip && window.tconfig.WIDGET_THEME_1) &&
            isInTripPlan && (
              <div
                className={classes.iconWrapper}
                onClick={showFavorites}
                onKeyPress={() => {}}
                role="button"
                tabIndex={0}
              >
                <SvgIcons.Favorite fill="#000" />
                <span className="text-xs mt-1">
                  {t("favorites" as Model.TranslationKey)}
                </span>
              </div>
            )}

          <div className={`${classes.mitem} ${classes.shape}`} />
          <div
            className={
              listShown ? `${classes.circle} ${classes.shadow}` : classes.circle
            }
          >
            <input
              className={listShown ? classes.mapIcon : classes.listIcon}
              type="button"
              onClick={showList}
            />
          </div>

          {/* OFFERS */}
          {/* {(window.tconfig.SHOW_OFFERS && !isGuest && readOnlyTrip === false) ||
            (window.tconfig.SHOW_OFFERS && isLoggedIn && window.tconfig.WIDGET_THEME_1 && isInTripPlan && (
              <div className={classes.iconWrapper} onClick={showOffers} onKeyPress={() => {}} role="button" tabIndex={0}>
                <SvgIcons.Offer2 width="20" height="20" />
              </div>
            ))} */}
          {!isGuestForSimplyCaribbean &&
            readOnlyTrip === false &&
            isInTripPlan &&
            isLoggedIn && (
              <div
                className={classes.iconWrapper}
                onClick={showOffers}
                onKeyPress={() => {}}
                role="button"
                tabIndex={0}
              >
                <SvgIcons.Offer2 width="22" height="22" stroke="#000" />
                <span className="text-xs mt-1">
                  {t("offers" as Model.TranslationKey)}
                </span>
              </div>
            )}

          {/* BOOKINGS */}
          {(window.tconfig.SHOW_RESTAURANT_RESERVATIONS ||
            window.tconfig.SHOW_TOURS_AND_TICKETS) &&
            readOnlyTrip === false &&
            !isGuestForSimplyCaribbean &&
            !(sharedTrip && window.tconfig.WIDGET_THEME_1) &&
            isInTripPlan && (
              <div
                className={`${classes.iconWrapper} ${classes.tooltip} md:!flex`}
                onClick={showBookings}
                onKeyPress={() => {}}
                role="button"
                tabIndex={0}
              >
                <SvgIcons.Bookmark fill="#000" />
                <span className="text-xs mt-1">
                  {t("bookings" as Model.TranslationKey)}
                </span>
              </div>
            )}
        </div>
      )}
    </div>
  );
};

export default Menu;
